/* eslint-disable react-hooks/exhaustive-deps */
import { fetchQuestionDetail } from '@/apis/help/help.api';
import UKLoadingIcon, { CIRCLE_COLOR_MAP } from '@/components/UKLoadingIcon';
import UKPageNothing from '@/components/UKPageNothing';
import { useTranslation } from '@/i18n/client';
import { Button } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
interface Props {
  title: string;
  sceneId: string;
  onConfirm: () => void;
}

const ConfirmButton = muiStyled(Button)(() => ({
  padding: '0 8px',
  minWidth: 'auto',
  lineHeight: '28px',
  color: 'var(--sys-background-White)',
  backgroundColor: 'var(--sys-color-Primary700)',
  '&:hover': {
    boxShadow: 'none',
    borderColor: 'var(--sys-color-Primary800)',
    backgroundColor: 'var(--sys-color-Primary800)',
  },
}));

export default function IntegralDialog({ title, sceneId, onConfirm }: Props) {
  const { t } = useTranslation();
  const [ruleDesc, setRuleDesc] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (sceneId) {
      getRuleDesc();
    }
  }, [sceneId]);

  const getRuleDesc = async () => {
    const { data, code } = await fetchQuestionDetail({ scene: sceneId });
    setIsLoading(false);
    if (code === '200' && data) {
      setRuleDesc(data.facadeContent);
    }
  };

  function DialogContent() {
    if (isLoading) {
      return (
        <div className={styles.loading}>
          <UKLoadingIcon type={CIRCLE_COLOR_MAP.BLACK} />
        </div>
      );
    }
    if (!ruleDesc) {
      return (
        <div className={styles.nothing}>
          <UKPageNothing style={{ marginTop: '-25px' }} />
        </div>
      );
    }
    return (
      <div className={styles.content}>
        <span dangerouslySetInnerHTML={{ __html: ruleDesc }} />
      </div>
    );
  }

  return (
    <div className={styles.integralDialog}>
      <div className={styles.title}>{title}</div>
      <DialogContent />
      {/* <div className={styles.btnWrap}>
        <ConfirmButton onClick={onConfirm}>{t("common.btnText.ok")}</ConfirmButton>
      </div> */}
    </div>
  );
}
